import { render, staticRenderFns } from "./SlugNameEdit.vue?vue&type=template&id=68881044&"
import script from "./SlugNameEdit.vue?vue&type=script&lang=ts&"
export * from "./SlugNameEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports